"use client";

import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

const ArrowIcon = () => (
	<svg
		className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M5 12h14M12 5l7 7-7 7" />
	</svg>
);

const GetQuoteSection = () => {
	const t = useTranslations("fiveAxisQuoteSection");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col items-center justify-between gap-6 md:flex-row md:gap-8">
					<p className="text-sm leading-relaxed text-black md:text-base">{t("description")}</p>
					<Link
						href="/upload"
						className="group inline-flex flex-shrink-0 items-center gap-2 rounded bg-[#64a525] px-5 py-3 text-sm font-medium text-white transition-all duration-300 hover:bg-[#5a9420] hover:text-white sm:px-6 sm:py-3.5 md:text-base"
					>
						{t("buttonText")}
						<ArrowIcon />
					</Link>
				</div>
			</div>
		</section>
	);
};

export default GetQuoteSection;
